<ng-container *ngIf="showcase.resources">
  <ul class="multiple-showcase-resources d-flex flex-wrap pt-md-0 list-unstyled m-0"
       [ngClass]="index === 0 ? 'pt-0' : 'pt-8'">
    <li class="resource-container mb-6 mx-2 mx-sm-3 d-flex align-items-end"
         *ngFor="let resource of showcase.resources; index as i;">
      <a class="resource"
         *ngIf="showcase.isExtendable && i !== resourcesPerMultipleShowcase || !showcase.isExtendable"
         [routerLink]="['/search', 'card']"
         [queryParams]="{id: resource.id, entityType: resource.entityType}"
         data-automation-id="multiple-showcase-resource-page-link">
        <div class="cdk-visually-hidden">{{ resource.title }}</div>
        <div class="image-container">
          <app-cover
            [tippy]="resource.title"
            [config]="resource.coverConfig"
            [title]="resource.title"
            data-automation-id="multiple-showcase-resource-image"
            size="medium">
          </app-cover>
        </div>
      </a>
      <a class="resource-more"
         *ngIf="showcase.isExtendable && i === resourcesPerMultipleShowcase"
         data-automation-id="multiple-showcase-resource-more-link"
         [routerLink]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', showcase.id] : ['/search', 'card']"
         [queryParams]="showcaseType !== showcasesTypes.CUSTOM ? {
                  id: showcase.id,
                  entityType: entityTypes.CONCEPT,
                  showcase: showcasesTypes.RESOURCES,
                  identifier: showcase.identifier
                } : null">
        <div class="resource-more-bg d-flex justify-content-center align-items-center h-100">
          <span class="cdk-visually-hidden" translate data-automation-id="multiple-showcase-resource-more-hint"
                [translateParams]="{ value: showcase.totalResources - resourcesPerMultipleShowcase }">showMoreTopicResourcesCount</span>
          <span class="resources-more-text" data-automation-id="multiple-showcase-resource-more-text"
            [attr.aria-hidden]="true" translate [translateParams]="{ value: showcase.totalResources - resourcesPerMultipleShowcase }">
            showMoreTopicResourcesCount
          </span>
        </div>
      </a>
    </li>
  </ul>
</ng-container>

<div class="topic-info mt-3 mx-3">
  <div class="multiple-showcase-title row">
    <div class="col-auto">
      <a class="multiple-showcase-link d-flex align-items-center border-0"
         data-automation-id="multiple-showcase-link"
         [routerLink]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', showcase.id] : ['/search', 'card']"
         [queryParams]="showcaseType !== showcasesTypes.CUSTOM ? {
                  id: showcase.id,
                  entityType: entityTypes.CONCEPT,
                  showcase: null,
                  identifier: null
                } : null">
        <div class="sr-only">{{ showcase.label }}</div>
        <span class="text line-clamp line-clamp--one"
              [tippy]="showcase.label"
              [attr.aria-hidden]="true">{{ showcase.label }}</span>
        <fa-icon class="arrow-icon" [icon]="arrowIconRight"></fa-icon>
      </a>
      <app-showcase-created-by [creator]="showcase.metadata?.creator"></app-showcase-created-by>
    </div>
  </div>
  <ng-container *ngIf="showcase.description">
    <div class="multiple-showcase-description mt-2" data-automation-id="multiple-showcase-description">
      <div class="sr-only">{{ showcase.description }}</div>
      <span class="line-clamp line-clamp--three"
            [tippy]="showcase.description"
            [attr.aria-hidden]="true">
        {{ showcase.description }}</span>
    </div>
  </ng-container>
</div>
